<script>
export default {
  props: {
    mediaPath: String,
  },
  data() {
    return {
      href: null,
    }
  },
  created() {
    this.downloadFile(this.mediaPath)
  },
  methods: {
    getContentTypeFromFileName(fileName) {
      const extension = fileName.split(".").pop().toLowerCase()

      const mimeTypes = {
        txt: "text/plain",
        html: "text/html",
        htm: "text/html",
        css: "text/css",
        js: "application/javascript",
        json: "application/json",
        png: "image/png",
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        gif: "image/gif",
        pdf: "application/pdf",
        zip: "application/zip",
        mp3: "audio/mpeg",
        mp4: "video/mp4",
      }

      return mimeTypes[extension] || "application/octet-stream"
    },
    async downloadFile(mediaPath) {
      if (mediaPath) {
        // * generate download presigned url with expiry time
        const downloadUrl = await this.$http.get(
          `/api/download-pre-signed-url/${mediaPath.replace(
            "/",
            "+"
          )}/${this.getContentTypeFromFileName(mediaPath).replace("/", "+")}`
        )


        // console.log(`download file response: ${response}`)

        // const blob = new Blob([response.data], {
        //   type: response.headers["content-type"],
        // })

        // this.href = URL.createObjectURL(blob)
        this.href = downloadUrl.data.download_url

        // add file reader here
        // const fileReader = new FileReader()

        // fileReader.readAsDataURL(blob)

        // fileReader.onload((event) => {
        //     // this.chatRooms[index].chats[chatIndex].file =
        //     //     event.target.result
        //     console.log(event.target.result)
        // })
      }
    },
  },
}
</script>

<template>
  <div
    class="d-flex flex-column justify-content-center align-items-center w-100 h-100 bg-white rounded-lg p-1"
  >
    <img
      v-if="getContentTypeFromFileName(mediaPath).includes('image')"
      :src="href"
      class="w-100 rounded-lg"
    />
    <!-- <video
      v-else-if="getContentTypeFromFileName(mediaPath) === 'video/mp4'"
      class="w-100 rounded-lg"
    >
      <source :src="href" type="video/mp4" />
      Your browser does not support the video tag.
    </video> -->
    <div
      class="d-flex flex-column justify-content-center align-items-center"
      v-else
    >
      <a :href="href" :download="mediaPath">
        <feather-icon icon="DownloadIcon" class="text-muted" size="50" />
      </a>
      <p class="mt-1 text-center text-dark">{{ mediaPath.split("/")[1] }}</p>
    </div>
  </div>
</template>
